import { DepartmentGroup, DepartmentGroupResource } from './DepartmentGroup'

export const transformToDepartmentGroup = (departmentGroup: DepartmentGroupResource): DepartmentGroup => ({
    id: departmentGroup.id,
    name: departmentGroup.attributes.name,
})
